import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { Page } from "src/app/model/Page";
import { UserModel } from "src/app/model/UserModel";
import { MasterService } from "src/app/services/master.service";
import { DefaultPasswordModalComponent } from "../au/default-password-modal/default-password-modal.component";

@Component({
  selector: "app-secure-user-list",
  templateUrl: "./user-list.component.html",
  styleUrls: ["./user-list.component.scss"],
})
export class UserListComponent implements OnInit {
  page: Page<UserModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<UserModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "userId",
    "userName",
    "roleName",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private router: Router,
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService.fetchUserList(this.currentPage, this.pageSize, this.filterForm.value.filterText).subscribe((page) => {
      this.page = page;
      this.dataSource = new MatTableDataSource(page.content);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });
      this.isSearchDisabled = false;
      this.isLoading = false;
    },
    (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.onLoad();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for User", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  edit(key: number) {
    this.router.navigate(['/secure', 'master', 'user', 'au', key]);
  }

  roleNames(roles: {[key: number]: string}) {
    return Object.keys(roles).reduce(function(res, v) {
      return res.concat(" " + roles[v]);
    }, []);
  }

  deactivate(key: number) {
    if(confirm("Do you want to De-Activate the User")) {
      this.masterService.toggleActivationUser(key, 'N').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'N';
        }
        else {
          this.errorToast(data.errorMessage);
        }
      });
    } 
  }
 
  activate(key: number) {
    if(confirm("Do you want to Activate the User")) {
      this.masterService.toggleActivationUser(key, 'Y').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'Y';
        }
        else {
          this.errorToast(data.errorMessage);
        }
      });
    } 
  }

  resetPassword(key: number) {
    if(confirm("Do you want to Reset Password for the User")) {
      this.masterService.resetUserPassword(key).subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          var selectedUser = this.page.content.find(o => o.key === key);
          this.successToast('Password has been reset to Default Password for User: '+selectedUser.userId);
        }
        else {
          this.errorToast(data.errorMessage);
        }
      });
    } 
  }

  async changeDefaultPassword() {
    const modal = await this.modalCtrl.create({
      component: DefaultPasswordModalComponent,
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
      
    if(role === 'submit') {
      this.masterService.changeDefaultPassword(data).subscribe((resp) => {
        if(resp.status === 'SUCCESS') {
          this.successToast('Default Password saved successfully.');
        }
        else {
          this.errorToast(resp.errorMessage);
        }
      }, error => {
        this.errorToast(error?.error?.message||error?.error?.errorMessage);
      });
    }
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}